jQuery(document).ready(function($) {

    $( ".bloc_formulaire" ).each(function( index ) {

        var parent = $(this)
        var contenu = parent.find(".form")
        var visuel = parent.find(".visuel")

        gsap.from( contenu, {
            y : +200,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 80%",
                end: "top 50%",
                scrub: 1,
            }

        })

        gsap.from( visuel, {
            y : +200,
            scale : .3,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 90%",
                end: "bottom 90%",
                scrub: 1,
            }

        })

    })

});